export default __webpack_public_path__ + "static/media/Untitled-11.64f06fe1.png";